// app/redux/store.ts
import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import createWebStorage from "redux-persist/lib/storage/createWebStorage";
import { IRootState } from "./rootReducer";
import rootReducer from "./rootReducer";
import { IAction } from "../configs/types";
import { EUserActionTypes } from "./users/userAction";

const createNoopStorage = () => {
  return {
    getItem(_key: string) {
      return Promise.resolve(null);
    },
    setItem(_key: string, value: any) {
      return Promise.resolve(value);
    },
    removeItem(_key: string) {
      return Promise.resolve();
    },
  };
};

const storage =
  typeof window !== "undefined"
    ? createWebStorage("local")
    : createNoopStorage();

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
  version: 1,
  // Add type information to the state
  stateReconciler: (inboundState: any, originalState: IRootState) => ({
    ...originalState,
    ...inboundState,
  }),
};

// Cast the reducer to work with both the root state and user actions
const typedRootReducer = rootReducer as unknown as (
  state: IRootState | undefined,
  action: IAction<EUserActionTypes>,
) => IRootState;

const persistedReducer = persistReducer(persistConfig, typedRootReducer);

const store = createStore(persistedReducer);

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export default store;
